import { Observable, of } from 'rxjs';
import { NewViewModelState } from './new-view-model-state';
import { UnchangedViewModelState } from './unchanged-view-model-state';
import { ViewModelState } from './view-model-state';
import type { ViewModelStateContextInterface } from '@nts/std/interfaces';
import { ViewModelStates } from '@nts/std/types';

export class ModifiedViewModelState extends ViewModelState {
  constructor(context: ViewModelStateContextInterface) {
    super(context);
  }

  get value() {
    return ViewModelStates.Modified;
  }

  override canRestore(): Observable<boolean> {
    return of(true);
  }

  override restore() {
    this.context.currentState = new UnchangedViewModelState(this.context);
  }

  override canCreate(): Observable<boolean> {
    return of(!this.startedAsRelatedClient);
  }

  override create() {
    this.context.currentState = new NewViewModelState(this.context);
  }

  override canStore(): Observable<boolean> {
    return of(true);
  }

  override store() {
    this.context.currentState = new UnchangedViewModelState(this.context);
  }

  override canRemove(): Observable<boolean> {
    return of(!this.context.isDeactivable && !this.startedAsRelatedClient);
  }

  override remove() {
    this.context.currentState = new NewViewModelState(this.context);
  }

  override canStoreAndCreate(): Observable<boolean> {
    return of(!this.startedAsRelatedClient);
  }

  override storeAndCreate() {
    this.context.currentState = new NewViewModelState(this.context);
  }

  override getByIdentity() {
    this.context.currentState = new UnchangedViewModelState(this.context);
  }

  override canStartRelatedClient() {
    return of(true);
  }
}
